import { createBrowserRouter, Navigate } from "react-router-dom";

// Main views
import AdminView from "./views/AdminView";
import UserView from "./views/UserView";

// User pages
import Element from "./pages/user-pages/element/Element";
import ContentPage from "./pages/user-pages/page-editor-content";
import Search from "./pages/user-pages/search";
import Unsubscribe from "./pages/user-pages/unsubscribe";

// Custom handler for BIMQ authentication callback
import BimqCallback from "./pages/admin-pages/bimq";

// Admin pages
import ElementCommentsDetails from "./pages/admin-pages/comments/elements-details";
import ElementCommentsOverview from "./pages/admin-pages/comments/elements-overview";
import PageCommentsDetails from "./pages/admin-pages/comments/pages-details";
import PageCommentsOverview from "./pages/admin-pages/comments/pages-overview";
import Dashboard from "./pages/admin-pages/dashboard";
import ElementPagesEditor from "./pages/admin-pages/database/editor";
import ElementPagesOverview from "./pages/admin-pages/database/overview";
import MediaDownloads from "./pages/admin-pages/media";
import PageEditor from "./pages/admin-pages/pages/editor";
import PageOverview from "./pages/admin-pages/pages/overview";
import SettingsBimqParameterDetails from "./pages/admin-pages/settings/bimq-parameters/details";
import SettingsBimqParameters from "./pages/admin-pages/settings/bimq-parameters/overview";
import SettingsDisciplineDetails from "./pages/admin-pages/settings/disciplines/details";
import SettingsDisciplines from "./pages/admin-pages/settings/disciplines/overview";
import SettingsFooterLinkDetails from "./pages/admin-pages/settings/footer/details";
import SettingsFooterLinks from "./pages/admin-pages/settings/footer/overview";
import SettingsFootnoteDetails from "./pages/admin-pages/settings/footnotes/details";
import SettingsFootnotes from "./pages/admin-pages/settings/footnotes/overview";
import SettingsLanguages from "./pages/admin-pages/settings/languages";
import SettingsNotificationDetails from "./pages/admin-pages/settings/notifications/details";
import SettingsNotification from "./pages/admin-pages/settings/notifications/overview";
import SettingsPhaseDetails from "./pages/admin-pages/settings/phases/details";
import SettingsPhases from "./pages/admin-pages/settings/phases/overview";
import SettingsSoftwareDetails from "./pages/admin-pages/settings/software/details";
import SettingsSoftware from "./pages/admin-pages/settings/software/overview";
import SettingsUseCasesDetails from "./pages/admin-pages/settings/use-cases/details";
import SettingsUseCases from "./pages/admin-pages/settings/use-cases/overview";
import TemplateEditor from "./pages/admin-pages/templates/editor";
import TemplatesOverview from "./pages/admin-pages/templates/overview";
import UserDetails from "./pages/admin-pages/users/details";
import UsersOverview from "./pages/admin-pages/users/overview";
import VersionManagement from "./pages/admin-pages/versions";

export const routes = createBrowserRouter([
    {
        id: "admin-entrypoint",
        element: <AdminView />,
        path: "admin",
        children: [
            {
                id: "admin-page",
                children: [
                    {
                        id: "auto-redirect-to-dashboard",
                        index: true,
                        element: <Navigate replace to="dashboard" />,
                    },
                    {
                        id: "admin-dashboard",
                        path: "dashboard",
                        children: [
                            {
                                id: "admin-dashboard-home",
                                index: true,
                                element: <Dashboard />,
                            },
                        ],
                    },
                    {
                        id: "admin-comments",
                        path: "element-comments",
                        children: [
                            {
                                id: "admin-element-comments-home",
                                index: true,
                                element: <ElementCommentsOverview />,
                            },
                            {
                                id: "admin-element-comments-detail",
                                path: ":identifier/:language",
                                element: <ElementCommentsDetails />,
                            },
                        ],
                    },
                    {
                        id: "admin-page-comments",
                        path: "page-comments",
                        children: [
                            {
                                id: "admin-page-comments-home",
                                index: true,
                                element: <PageCommentsOverview />,
                            },
                            {
                                id: "admin-page-comments-detail",
                                path: ":slug/:language",
                                element: <PageCommentsDetails />,
                            },
                        ],
                    },
                    {
                        id: "admin-media",
                        path: "media",
                        children: [
                            {
                                id: "admin-media-downloads",
                                path: "downloads",
                                element: <MediaDownloads />,
                            },
                        ],
                    },
                    {
                        id: "admin-templates",
                        path: "templates",
                        children: [
                            {
                                id: "admin-templates-overview",
                                index: true,
                                element: <TemplatesOverview />,
                            },
                            {
                                id: "admin-templates-new",
                                path: "new",
                                element: <TemplateEditor />,
                            },
                            {
                                id: "admin-templates-detail",
                                path: ":identifier",
                                element: <TemplateEditor />,
                            },
                        ],
                    },
                    {
                        id: "admin-pages",
                        path: "pages",
                        children: [
                            {
                                id: "admin-pages-overview",
                                // path: ":identifier",
                                index: true,
                                element: <PageOverview />,
                            },
                            {
                                id: "admin-pages-new",
                                path: "new",
                                element: <PageEditor />,
                            },
                            {
                                id: "admin-pages-detail",
                                path: ":identifier",
                                element: <PageEditor />,
                            },
                        ],
                    },
                    {
                        id: "admin-database",
                        path: "database",
                        children: [
                            {
                                id: "admin-database-elements",
                                index: true,
                                element: <ElementPagesOverview />,
                            },
                            {
                                id: "admin-database-elements-detail",
                                path: ":identifier/:language",
                                element: <ElementPagesEditor />,
                            },
                        ],
                    },
                    {
                        id: "admin-versions",
                        path: "versions",
                        children: [
                            {
                                id: "admin-versions-overview",
                                index: true,
                                element: <VersionManagement />,
                            },
                        ],
                    },
                    {
                        id: "admin-users",
                        path: "users",
                        children: [
                            {
                                id: "admin-users-overview",
                                index: true,
                                element: <UsersOverview />,
                            },
                            {
                                id: "admin-users-detail",
                                path: ":identifier",
                                element: <UserDetails />,
                            },
                        ],
                    },
                    {
                        id: "admin-settings",
                        path: "settings",
                        children: [
                            {
                                id: "admin-settings-languages",
                                path: "languages",
                                element: <SettingsLanguages />,
                            },
                            {
                                id: "admin-settings-bimq-parameters",
                                path: "bimq-parameters",
                                children: [
                                    {
                                        id: "admin-settings-bimq-parameters-overview",
                                        index: true,
                                        element: <SettingsBimqParameters />,
                                    },
                                    {
                                        id: "admin-settings-bimq-parameters-detail",
                                        path: ":identifier",
                                        element: <SettingsBimqParameterDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-disciplines",
                                path: "disciplines",
                                children: [
                                    {
                                        id: "admin-settings-disciplines-overview",
                                        index: true,
                                        element: <SettingsDisciplines />,
                                    },
                                    {
                                        id: "admin-settings-disciplines-detail",
                                        path: ":identifier",
                                        element: <SettingsDisciplineDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-phases",
                                path: "phases",
                                children: [
                                    {
                                        id: "admin-settings-phases-overview",
                                        index: true,
                                        element: <SettingsPhases />,
                                    },
                                    {
                                        id: "admin-settings-phases-detail",
                                        path: ":identifier",
                                        element: <SettingsPhaseDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-software",
                                path: "software",
                                children: [
                                    {
                                        id: "admin-settings-software-overview",
                                        index: true,
                                        element: <SettingsSoftware />,
                                    },
                                    {
                                        id: "admin-settings-software-detail",
                                        path: ":identifier",
                                        element: <SettingsSoftwareDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-use-cases",
                                path: "use-cases",
                                children: [
                                    {
                                        id: "admin-settings-use-cases-overview",
                                        index: true,
                                        element: <SettingsUseCases />,
                                    },
                                    {
                                        id: "admin-settings-use-cases-detail",
                                        path: ":language/:identifier",
                                        element: <SettingsUseCasesDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-footnotes",
                                path: "footnotes",
                                children: [
                                    {
                                        id: "admin-settings-footnotes-overview",
                                        index: true,
                                        element: <SettingsFootnotes />,
                                    },
                                    {
                                        id: "admin-settings-footnotes-detail",
                                        path: ":identifier",
                                        element: <SettingsFootnoteDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-notifications",
                                path: "notification",
                                children: [
                                    {
                                        id: "admin-settings-notifications-overview",
                                        index: true,
                                        element: <SettingsNotification />,
                                    },
                                    {
                                        id: "admin-settings-notifications-detail",
                                        path: ":identifier",
                                        element: <SettingsNotificationDetails />,
                                    },
                                ],
                            },
                            {
                                id: "admin-settings-footer-links",
                                path: "footer-links",
                                children: [
                                    {
                                        id: "admin-settings-footer-links-overview",
                                        index: true,
                                        element: <SettingsFooterLinks />,
                                    },
                                    {
                                        id: "admin-settings-footer-links-detail",
                                        path: ":identifier",
                                        element: <SettingsFooterLinkDetails />,
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
    {
        id: "bimq-callback-entrypoint",
        children: [
            {
                id: "local-authentication",
                path: "callback",
                Component: BimqCallback,
            },
            {
                id: "live-authentication",
                path: "bimq-auth-callback",
                Component: BimqCallback,
            },
        ],
    },
    {
        id: "user-entrypoint",
        Component: UserView,
        children: [
            {
                id: "localised-pages",
                path: ":locale?",
                children: [
                    {
                        id: "content-page-index",
                        index: true,
                        Component: ContentPage,
                    },
                    {
                        id: "unsubscribe-page",
                        path: "unsubscribe/:identifier",
                        Component: Unsubscribe,
                    },
                    {
                        id: "search-page",
                        path: "search",
                        Component: Search,
                    },
                    {
                        id: "ssadfge",
                        path: "a",
                        Component: Element,
                    },
                    {
                        id: "custom-content-pages",
                        path: "*",
                        Component: ContentPage,
                    },
                ],
            },
        ],
    },
]);
